import { Component, Injector, Input, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { WidgetBaseComponent } from '../../widgetBase';

/**
 * DcfLeasingAndRenewalAssumptions Widget
 */
@Component({
  selector: 'dcf-leasing-and-renewal-assumptions-widget',
  templateUrl: './dcf-leasing-and-renewal-assumptions-widget.component.html',
  styleUrls: ['./dcf-leasing-and-renewal-assumptions-widget.component.scss']
})
export class DcfLeasingAndRenewalAssumptionsWidgetComponent extends WidgetBaseComponent implements OnInit {

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
  * Constructor
  */
  constructor(injector: Injector) {
    super(injector, 'dcfLeasingAndRenewalAssumptions', false);
  }

  /**
   * Widget's text area options (if used)
   */
  textAreaOptions: any = null;

  /**
   * Initializes the component
   */
  ngOnInit() {
    // will call registerEvents and onInitialized when config (this.widgetConfig and this.page) is ready

    this.initWidgetConfig();
    this.widgetResized();
  }

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {
    this.useDefaultServiceSaveChangesHandler("dcfleasingandrenewalassumptions", this.provideSaveObject.bind(this));
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {
    this.widgetData$ = this.mockup ?
    this.widgetService.loadMockup('dcfleasingandrenewalassumptions').pipe(take(1))
      : this.widgetService.load('dcfleasingandrenewalassumptions', this.getReport()).pipe();
  }

  /**
   * Called by base class in save process. Widget should return object to be saved
   */
  async provideSaveObject(): Promise<any> {
    return this.widgetData;
  }

  /**
   * Called by base class to inform widget about save action result
   * @param _success {boolean} The result of save action
   * @param _err {any} The error object, if save action failed
   */
  saveCompleted(_success: boolean, _err: any = null): void {
    //do something if error
  }

  /**
   * Returns start date
  * @param date {Date} Date
  * @param index {number} Index
   */
  getStartDate(date: Date, index: number): Date{
    const newDate = new Date(date)
    newDate.setFullYear(newDate.getFullYear() + index - 1)
      return newDate;
  }

  /**
   * Returns end date
  * @param date {Date} Date
  * @param index {number} Index
   */
  getEndDate(date: Date, index: number): Date {
    const newDate = new Date(date);
    const year = newDate.getFullYear() + index - 1
    newDate.setDate(newDate.getDate() - 1);
    newDate.setFullYear(year);
    if (this.leapYear(year) && newDate.getMonth() === 1) {
      newDate.setDate(29);
    }
    return newDate;
  }

  /**
   * Checks if year is leap year
  * @param year {any} Year
   */
  leapYear(year): boolean {
    return ((year % 4 == 0) && (year % 100 != 0)) || (year % 400 == 0);
  }
}

